import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrThickArrowRightIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M4.33468 1.34178C3.8884 1.79744 3.88844 2.53617 4.33479 2.99178L9.24085 7.99969L4.33474 13.0083C3.88842 13.4639 3.88842 14.2026 4.33474 14.6583C4.78105 15.1139 5.50467 15.1139 5.95098 14.6583L11.6653 8.82464C11.8796 8.60582 12 8.30905 12 7.9996C12 7.69015 11.8796 7.39338 11.6652 7.17458L5.95093 1.34167C5.50459 0.886068 4.78097 0.886114 4.33468 1.34178Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrThickArrowRightIconComponent;
